/**
 * 描述：公用底部
 * 日期：2017-9-25、
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module("publicFooterModule", []).
directive("publicFooter", [function() {
    return {
        replace: true,
        restrict: 'E',
        template: ['<div class="footer">',
            '<div class="foot_text">',
            '2019 新疆吉木萨尔县融媒体中心 拓尔思信息技术股份有限公司 版权所有 保留所有权 本系统支持1366*768及以上分辨率',
            '</div></div>'
        ].join(""),
    };
}]);